import { Theme } from '@shared/models/theme';
import { createContext } from 'react';

export const ThemeContext = createContext<Theme>('dark');
